const SELF_PAY_VALUES = new Set(['self', 'child', 'self-pay', 'self pay'])

export const toLocationPayloadBillTo = billTo => {
  const normalized = String(billTo || '')
    .trim()
    .toLowerCase()

  return SELF_PAY_VALUES.has(normalized) ? 'self' : 'parent'
}

export const toSingleLocationPayloadBillTo = () => 'parent'

export const getFirstChildPayloadBillTo = (
  childValues = {},
  parentValues = {},
) => toLocationPayloadBillTo(childValues.billTo || parentValues.billTo)
